import { css } from '@emotion/react';
import { styled } from '@mui/material/styles';
import { UiFba } from 'ui-components';
import { left } from 'utils';

export const StyledBackToTopButton = styled(UiFba)(
  ({ theme }) => css`
    position: absolute !important;
    bottom: 16px;
    ${left('16px')}
    width: 32px;
    min-height: 32px;
    height: 32px;
    background-color: #0c395a;
    border: 1px solid #3c607a;
    z-index: ${theme.zIndex.fab};
    gap: 4px;
    color: ${theme.palette.common.white};
    .text {
      display: none;
    }
    &:hover,
    &:active {
      background-color: #0c395a;
      border: 1px solid #3c607a;
    }
    &:hover {
      border-radius: 16px;
      width: 120px;
      .text {
        display: block;
      }
    }
  `
);
